import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '../hooks/useTheme';

// Components
import Header from '../components/landing/Header';
import LoginForm from '../components/auth/LoginForm';
import Footer from '../components/landing/Footer';

const LoginPage = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <div className={`landing-page theme-${theme}`}>
            <Helmet>
                <title>Iniciar Sesión - Laptops.pe</title>
                <meta name="description" content="Inicia sesión en tu cuenta de Laptops.pe para acceder a ofertas exclusivas y gestionar tus pedidos." />
                <meta property="og:title" content="Iniciar Sesión - Laptops.pe" />
                <meta property="og:description" content="Inicia sesión en tu cuenta de Laptops.pe." />
                <meta property="og:type" content="website" />
                <link rel="canonical" href={`${process.env.REACT_APP_SITE_URL}/login`} />
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <Header theme={theme} onToggleTheme={toggleTheme} />
            
            <main className="landing-main">
                <div className="container py-6">
                    <div className="flex justify-content-center">
                        <div className="col-12 md:col-8 lg:col-6 xl:col-4">
                            <div className="surface-card border-round p-6 shadow-2">
                                <div className="text-center mb-6">
                                    <h1 className="text-3xl font-bold mb-2">Iniciar Sesión</h1>
                                    <p className="text-color-secondary">
                                        Accede a tu cuenta para continuar
                                    </p>
                                </div>
                                
                                <LoginForm />
                                
                                <div className="text-center mt-4">
                                    <p className="text-color-secondary">
                                        ¿No tienes una cuenta?{' '}
                                        <a href="/registro" className="text-primary font-semibold">
                                            Regístrate aquí
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            
            <Footer />
        </div>
    );
};

export default LoginPage;
